// src/data/blogData.js

export const blogs = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=900",
    title:
      "How Businesses Lose Insurance Claims Due to Missing Asset Records",
    author: "Poll Ghosh",
    date: "July 24, 2026",
    link:
      "https://socialflylive.com/how-businesses-lose-insurance-claims/",
    cta: "Read about insurance claims",
  },

  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?w=900",
    title: "Asset Condition & Lifecycle Tracking Software",
    author: "Poll Ghosh",
    date: "July 20, 2026",
    link:
      "https://socialflylive.com/asset-condition-lifecycle-tracking-software/",
    cta: "Explore lifecycle tracking",
  },

  // {
  //   id: 3,
  //   image:
  //     "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=900",
  //   title: "Why 2026 Scammers No Longer Break In, They Log In.",
  //   author: "Sourav Das",
  //   date: "June 6, 2026",
  //   link:
  //     "https://socialflylive.com/why-2026-scammers-no-longer-break-in-they-log-in/",
  //   cta: "Read the security insights",
  // },

  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=900",
    title: "How Poor Maintenance Scheduling Shortens Server Lifespans",
    author: "Anuj Das",
    date: "May 26, 2026",
    link:
      "https://socialflylive.com/how-poor-maintenance-shortens-server-lifespans/",
    cta: "Explore maintenance planning",
  },
];